import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { BackButtonProps } from "@/types";
import { getParams, navigateBack, navigateTo, Routes } from "@/router";
import TextButton from "./TextButton.vue";


/**
 * A generic back button
 */
const __default__ = {
  name: "BackButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: {},
    route: {},
    toProject: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const buttonLabel = computed(() => {
  if (props.toProject) {
    return "Back To Project";
  } else if (props.label) {
    return props.label;
  } else {
    return "Go Back";
  }
});

/**
 * Routes back to the given page.
 */
function handleClick(): void {
  if (props.toProject) {
    navigateTo(Routes.ARTIFACT, getParams());
  } else if (props.route) {
    navigateTo(props.route);
  } else {
    navigateBack();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextButton, {
    text: "",
    icon: "back",
    label: buttonLabel.value,
    onClick: handleClick
  }, null, 8, ["label"]))
}
}

})